import { SaveOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const SaveBtn = ({ icon, ...others }) => {
  return (
    <Button
      color="primary"
      variant="solid"
      icon={!icon ? <SaveOutlined /> : icon}
      {...others}
    >
      Guardar
    </Button>
  );
};
